import { render, staticRenderFns } from "./addNewSupplier.vue?vue&type=template&id=9f5c9900&scoped=true"
import script from "./addNewSupplier.vue?vue&type=script&lang=js"
export * from "./addNewSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5c9900",
  null
  
)

export default component.exports